import {
  DATA_LOADER_MISMATCH_CODE,
  SAFE_LOADER_ERROR_CODES,
} from "@shared/constants/safeLoaderErrors";

/**
 * Identifies the conflict error `useSafeLoaderData` throws while a hard reload is already in
 * flight, so error boundaries can stay silent for something the app recovers from on its own.
 */
const isDataLoaderMismatchError = (error: unknown) => {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    error.status === SAFE_LOADER_ERROR_CODES.conflict &&
    "code" in error &&
    error.code === DATA_LOADER_MISMATCH_CODE
  );
};

export { isDataLoaderMismatchError };
